import {useTranslation} from "react-i18next";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import clsx from "clsx";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

import {apiUrl} from "../../../../../api/baseURL";
import RestoreFileIcon from "../../../../../images/icons/restoreFile.svg";
import {formFileUrlFromFileString} from "../../../../../utilities/generalConstants.js/generalConstants";
import ToolTip from "../../../../../utilities/ToolTip";
import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../../../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

const PdfPreviewItem = ({
  file,
  delFunc,
  restoreFunc = () => {},
  showPdfPreview,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
}) => {
  const {t} = useTranslation();

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  const url = typeof file === "string" ? formFileUrlFromFileString(file) : file.fileUrl;
  const format = url.split(".").pop();
  const isExcel = format === "xls" || format === "xlsx";
  const isFileDeleted = file?.deletedAt || (typeof file === "string" && file?.includes("|DELETED"));

  return (
    <div
      className={clsx("previewBoxItem", isFileDeleted && "fileDeleted")}
      style={{...(format === "pdf" ? {height: "unset"} : {})}}
    >
      <div>
        {format === "pdf" ? (
          <div className="fcCol gap">
            <span style={{width: "15rem", wordWrap: "break-word"}}>
              {url?.split("/")?.at(-1)?.split("_")?.slice(2, -1).join("_") || url.split("/").pop() || url || ""}
            </span>
            {showPdfPreview && (
              <iframe
                src={`${apiUrl}/${url}#toolbar=0&navpanes=0`}
                title={url.split("/").pop() || "pdf"}
                width="200"
                height="200"
                style={{border: "1px dashed #b9c3d0", background: "#fff", objectFit: "cover"}}
              />
            )}
          </div>
        ) : isExcel ? (
          <div className="fcCol">
            <span style={{width: "15rem", wordWrap: "break-word"}}>{url.split("/").pop()}</span>
          </div>
        ) : (
          <img src={url ? `${apiUrl}/${url}` : ""} alt="" width="200px" height="200px" draggable="false" />
        )}
      </div>
      {!isDisabledByRoutePermission && delFunc && !isFileDeleted && (
        <div style={{position: "absolute", top: "-4px", right: "-4px", cursor: "pointer"}}>
          <ToolTip title={t("Delete image")}>
            <CancelOutlinedIcon
              onClick={() => {
                Swal.fire({
                  title: "",
                  text: t("Sure"),
                  icon: "question",
                  confirmButtonText: t("Yes"),
                  showCancelButton: true,
                  cancelButtonText: t("No"),
                  customClas: {
                    popup: "zindex",
                    container: "zindex",
                    htmlContainer: "zindex",
                  },
                }).then(value => {
                  if (value.isConfirmed) {
                    delFunc(typeof file === "string" ? url : file.fileId);
                  }
                });
              }}
              sx={{background: "aliceblue", borderRadius: "50%"}}
            />
          </ToolTip>
        </div>
      )}
      {!isDisabledByRoutePermission && isFileDeleted && (
        <div style={{position: "absolute", top: "-4px", right: "-4px", cursor: "pointer"}}>
          <ToolTip title={t("Restore image")}>
            <img
              src={RestoreFileIcon}
              onClick={() => {
                Swal.fire({
                  title: "",
                  text: t("Sure"),
                  icon: "question",
                  confirmButtonText: t("Yes"),
                  showCancelButton: true,
                  cancelButtonText: t("No"),
                  customClas: {
                    popup: "zindex",
                    container: "zindex",
                    htmlContainer: "zindex",
                  },
                }).then(value => {
                  if (value.isConfirmed) {
                    restoreFunc(typeof file === "string" ? url : file.fileId);
                  }
                });
              }}
              // sx={{background: "aliceblue", borderRadius: "50%"}}
            />
          </ToolTip>
        </div>
      )}
    </div>
  );
};

PdfPreviewItem.propTypes = {
  url: PropTypes.string,
  delFunc: PropTypes.func,
};

export default PdfPreviewItem;
